module.exports = __webpack_public_path__ + "img/joone_white.8ffa4736.png";